import { connect } from 'react-redux'
import { Component } from "macguffin"
import { Stage } from 'mc_pixi-fiber'
import { Loader } from "pixi.js"
const { resources } = Loader.shared

import ArrayHelper from "utils/ArrayHelper"
import GameMode from "game/modes"
import GameModeGroup from "game/modes/GameModeGroup"
import Comet from "./Comet"

import { setCometWildsMovementComplete } from "game/redux/actions"

import { getReplacements } from "game/components/reels"

const { min } = Math
const { assign, keys } = Object

const CometVisibleGroup = new GameModeGroup([GameMode.RESPIN, GameMode.COMET_WILDS])

@connect(state => ({
    currentGameMode: state.game.currentGameMode,
    currentCometWildsData: state.game.currentCometWildsData,
    currentSpinData: state.game.currentSpinData,
    reelStoppedIndex: state.game.reelStoppedIndex,
    respinSummary: state.game.respinSummary,
    globalPaused: state.base.paused,
    reelsConfig: state.game.reelsConfig,
}), {
    setCometWildsMovementComplete
})

export default class CometWilds extends Component {

    constructor() {
        super()

        const prepare = [
            resources["badge"].texture.baseTexture,
            resources["wildText"].texture.baseTexture,
            resources["meteor_atlas_page_meteor_spine.png"].texture.baseTexture
        ]

        this.state = { prepare }
    }

    componentWillReceiveProps(nextProps) {
        const currentProps = this.props
        const newState = {
            resuming: undefined
        }

        if (nextProps.reelStoppedIndex >= 0 && nextProps.reelStoppedIndex !== currentProps.reelStoppedIndex) {
            const { reelsConfig = {}, currentSpinData = {} } = nextProps
            const { endStickyWilds = [], symbolReplacements, grid, stops, symbols } = currentSpinData
            const { comets = [] } = this.state

            const { grids } = reelsConfig
            const { reels } = grids[grid]
            const replacements = getReplacements(symbolReplacements, reels)

            endStickyWilds.forEach((wild, index) => {
                const reelIndex = wild.x - 1
                const symbolIndex = wild.y - 1
                const reelReplacements = replacements[reelIndex]
                const stop = (stops[reelIndex] + symbolIndex - 1) % reels[reelIndex].length

                const replacement = reelReplacements.find((replacement) => {
                    return (replacement.y - 1) === stop
                })

                if (replacement) {
                    wild.turnsLeft = min(replacement.turnsLeft, wild.turnsLeft)
                }

                if (!comets[index] && (wild.x - 1) === nextProps.reelStoppedIndex) {
                    comets[index] = wild
                    this.setState({ comets })
                    return
                }
            })
        }

        if (nextProps.currentCometWildsData !== currentProps.currentCometWildsData) {
            const comets = this.getUpdatedPositions(nextProps)
            assign(newState, { comets })
        }

        if (nextProps.currentGameMode !== currentProps.currentGameMode) {
            if (!CometVisibleGroup.contains(nextProps.currentGameMode)) {
                assign(newState, { comets: undefined })
            }

            if (nextProps.currentGameMode === GameMode.COMET_WILDS && currentProps.currentGameMode === GameMode.RESUME) {
                assign(newState, { resuming: true })
            }
        }

        if (keys(newState).length) {
            this.setState(newState)
        }
    }

    getUpdatedPositions(props) {
        const { currentCometWildsData, setCometWildsMovementComplete } = props
        const { startStickyWilds = [] } = currentCometWildsData || {}

        const lastIndex = startStickyWilds && ArrayHelper(startStickyWilds).lastIndex()

        const comets = startStickyWilds.map((wild, index) => {
            if (index === lastIndex) {
                wild.movementComplete = setCometWildsMovementComplete
            }

            return wild
        })

        return comets
    }

    renderComets() {
        const { props, state } = this
        const { width, height, respinSummary, globalPaused, reelStoppedIndex } = props
        const { comets, resuming } = state

        const cometWidth = width / 5
        const cometHeight = height / 3

        const cometElements = comets.map((comet, index) =>
            <Comet
                key = {index}
                index = {index}
                width = {cometWidth}
                height = {cometHeight}
                positions = {comet}
                onStart = {comet.movementComplete}
                respinSummary = {respinSummary}
                paused = { globalPaused }
                resuming = { resuming }
                reelStoppedIndex = { reelStoppedIndex }
        />)

        /*
            sort the comets so that the turns left badges are always (mostly) visible.
            We could've separated them onto another layer, but keeping track of positions would've been a nightmare
        */
        cometElements.sort((a, b) => {
            const { positions: aPositions } = a.props
            const { positions: bPositions } = b.props

            const { x: aX, y: aY } = aPositions
            const { x: bX, y: bY } = bPositions

            return (bY - aY) || (bX - aX)
        })

        return cometElements
    }

    render() {
        const { props, state } = this
        const { left, top, width, height, resolution, visibility, respinSummary, globalPaused } = props
        const { comets, prepare } = state

        const style = {
            top: `${top}px`,
            left: `${left}px`,
            visibility
        }

        return (
            <div className="cometWildsContainer" style={style}>
                <Stage
                    key = "cometWildsCanvas"
                    style = {{ width, height }}
                    {...{
                        resolution: resolution,
                        width:width,
                        height: height,
                        paused: globalPaused || !comets,
                        options: {
                            prepare,
                            transparent: true,
                            backgroundColor: 0x000000,
                            antialias: true,
                        }
                    }}
                >
                {
                    comets && this.renderComets()
                }
                </Stage>
            </div>
        )
    }
}
